import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchStitchingReg } from '../../../Store/PHPSlice/Stitching/StitchApi';
import { selectStitchReg } from '../../Selectors/StitchSelector/StitchingSelectors';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';
import axios from 'axios';
import SOMatOutViewIssue from '../../Sale/View/SOMatOutViewIssue';

const StitchingInfo = () => {
    const [formData, setFormData] = useState({
        dt: '',
        stMemo: '',
        ctMemo: '',
        empNm: '',
        itemNm: '',
        sono: '',
        soId: '',
        mcloth: '',
        mclothNm: '',
        m1cloth: '',
        m1clothNm: '',
        m2cloth: '',
        m2clothNm: '',
        m3cloth: '',
        m3clothNm: '',
        totQty: '',
        instruction: '',
        totmat: '',
        firmId: ''
    });
    const { Id } = useParams();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [material, setMaterial] = useState([]);
    const [soMaterial, setSoMaterial] = useState([]);
    const dispatch = useDispatch();
    const stitchlist = useSelector(selectStitchReg);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchStitchingReg(Id));
        fetchMaterialProductionList(Id);
    }, [Id, dispatch]);
    useEffect(() => {
        if (stitchlist.data && stitchlist.data.length > 0) {
            const item = stitchlist.data[0];
            setFormData(prev => ({
                ...prev,
                dt: item.dt,
                stMemo: item.stMemo,
                ctMemo: item.ctMemo,
                totQty: item.totQty,
                instruction: item.instruction,
                empNm: item.empNm,
                itemNm: item.itemNm,
                soId: item.soId,
                sono: item.sono,
                mcloth: item.mcloth || '',
                mclothNm: item.mclothNm || '',
                m1cloth: item.m1cloth || '',
                m1clothNm: item.m1clothNm || '',
                m2cloth: item.m2cloth || '',
                m2clothNm: item.m2clothNm || '',
                m3cloth: item.m3cloth || '',
                m3clothNm: item.m3clothNm || '',
                totmat: item.totmat || '',
                firmId: item?.firmId || '',
                fmemo: item?.fmemo || '',
            }));
        }
        if (stitchlist?.Info2?.length > 0) {
            const value = stitchlist?.Info2;
            setMaterial(value);
        }
    }, [stitchlist]);

    const fetchMaterialProductionList = async (id) => {
        const departNm = "STITCHING";
        try {
            const res = await axios.get(`${baseUrl}?apicall=getMaterialProduction_Issuedata_departNm_prodid&departNm=${departNm}&prod_id=${id}`)
            // console.log(res.data);
            setSoMaterial(res.data?.data || []);
        } catch (error) {
            console.error('error', error);
        }
    };
    // console.log(stitchlist);


    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    var itemData = stitchlist?.Info?.length > 0 ? {
        size: stitchlist?.Info?.map(val => val.size),
        ctqty: stitchlist?.Info?.map(val => parseFloat(val.ctqty)),
        fqty: stitchlist?.Info?.map(val => parseFloat(val.fqty)),
        issqty: stitchlist?.Info?.map(val => parseFloat(val.issqty)),
        balqty: stitchlist?.Info?.map(val => parseFloat(val.balqty)),
    } : [];


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '1%', width: '100%' }} ref={componentRef}>
                        {formData?.firmId !== '' && <FirmHeaderImg firmId={formData.firmId} />}
                        <h3 className='centered-heading'>Stitching Info</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dt}</td>

                                    <td style={{ width: '200px' }}>Stitch Memo No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.stMemo}</td>
                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Fusion Memo No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.fmemo}</td>

                                    <td style={{ width: '200px' }}>Cutting Memo No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.ctMemo}</td>

                                </tr>

                                {formData.soId !== '0' &&

                                    <tr>
                                        <td style={{ width: '200px' }}>Sale Order No.</td>
                                        <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono}</td>

                                    </tr>
                                }
                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Item</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.itemNm}</td>


                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Issue Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totQty}</td>
                                    <td style={{ width: '200px' }}>Issue Material Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totmat}</td>
                                </tr>

                            </tbody>
                        </table>
                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>


                                <tr>
                                    <td style={{ width: '100px' }}>Main Cloth</td>
                                    <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.mclothNm}</td>

                                </tr>

                                {formData.m1cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-1</td>
                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m1clothNm}</td>
                                    </tr>
                                }

                                {formData.m2cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-2</td>
                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m2clothNm}</td>
                                    </tr>
                                }

                                {formData.m3cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-3</td>
                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m3clothNm}</td>
                                    </tr>
                                }


                            </tbody>

                        </table>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>
                                <tr>

                                    <td style={{ width: '200px' }}>Stitching Instructions</td>
                                    <td style={{ width: '800px', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.instruction}</td>

                                </tr>
                            </tbody>
                        </table>

                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Size</TableCell>
                                        {itemData?.size ? itemData?.size?.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                        )) : null}
                                    </TableRow>


                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Cut Qty.</TableCell>
                                        {itemData?.ctqty ? itemData?.ctqty?.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                        )) : null}
                                    </TableRow>

                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Fusion Qty.</TableCell>
                                        {itemData?.fqty ? itemData?.fqty?.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                        )) : null}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                        {itemData?.issqty ? itemData?.issqty?.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                        )) : null}
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </TableContainer>

                        {/* <div>

                            <table style={{ width: '80%', margin: '1% 5%' }}>
                                <thead>
                                    <tr>
                                        <th>Sr. No.</th>
                                        <th>Material Work</th>
                                        <th>Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {material?.map((mat, matIndex) => (
                                        <>
                                            <tr key={matIndex}>
                                                <td>
                                                    {matIndex + 1}
                                                </td>
                                                <td>
                                                    {mat.materialNm}
                                                </td>
                                                <td>
                                                    {mat.qty}
                                                </td>


                                            </tr>
                                        </>
                                    ))}
                                    <tr>
                                        <td> </td>
                                        <td>
                                            <span className="tot-lump">Total Qty</span>
                                        </td>
                                        <td>
                                            <span className="tot-lump">{formData.totmat}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div> */}

                        {
                            soMaterial.length > 0 &&
                            <div style={{ marginLeft: '5%' }}>
                                <h3>Material Details</h3>
                                <SOMatOutViewIssue array={soMaterial} qtyArr={itemData?.issqty} />
                            </div>
                        }

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default StitchingInfo;
